/**
 * useRefetchOnNavigation Hook
 * Automatically refetches data when navigating between routes
 * Cost-effective: only refetches when route changes, not on every render
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useRefetchOnNavigation = (refetch: () => void) => {
  const location = useLocation();

  useEffect(() => {
    // Refetch data when route changes
    refetch();
  }, [location.pathname, refetch]);
};
